import { Box, Grid, LinearProgress, useMediaQuery, useTheme } from '@mui/material';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToolsCompany } from '../../components/custom';
import { VCard } from '../../components/shared';
import { CustomAlert } from '../../components/shared/VAlert';
import { useAuthContext } from '../../context';
import { LayoutBase } from '../../layouts';
import { IListCompany, CompanyServices } from '../../services/api/company/CompanyServices';

export const Company = () => {
    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));
    
    const navigate = useNavigate();
    const { userData } = useAuthContext();
    const [data, setData] = useState<IListCompany[]>();
    const [isLoading, setIsLoading] = useState(true);
    const [alertInfo, setAlertInfo] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'warning' | 'info' }>({
        open: false,
        message: '',
        severity: 'success'
    });

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        if(userData.nivel !== 'adm'){
            window.location.href = 'http://localhost:3000/home';
        } else {
            CompanyServices.get()
             .then((result) => {
                if(result instanceof Error) {
                    setAlertInfo({ open: true, message: 'Não foi possível listar empresas! ' + result.message, severity: 'error'});
                    setTimeout(() => {
                        navigate('/companies/company_registration/novo');
                    }, 2000);
                } else {
                    const filteredData = result.filter(empresa => empresa.status);
                    setData(filteredData);    
                    setIsLoading(false);
                    if (filteredData.length == 0) {
                        setAlertInfo({ open: true, message: 'Sem empresas ativas, você precisa cadastrar uma nova!', severity: 'info' });
                        // setTimeout(() => {
                        //     navigate('/companies/company_registration/novo');
                        // }, 2800);
                    }
                }
             });
        }
    };   

    function handleEdit(uuid: string) {
        navigate(`/companies/company_registration/${uuid}`);
    }

    return (
        <LayoutBase
            title='Empresas'
            tollBar={(
                <ToolsCompany />
            )}
        >
            <Box margin={0} display={'flex'} flexDirection={'column'}>
                {isLoading ? 
                    <LinearProgress/>
                    :
                    <Grid container direction={'column'} padding={2} spacing={2}>
                        <Grid container direction={'row'} spacing={4} padding={1}>
                            {data?.map((empresa, index) => (
                                <Grid key={index} item xs={smDown ? 12 : 4} xl={smDown ? 6 : 4}>
                                    <VCard
                                        labelAtt={false}
                                        title={empresa.nome}
                                        imageUrl={empresa.image}
                                        button1Label='Editar'
                                        onButton1Click={() => handleEdit(empresa.uuid)}
                                        company={true}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                }
                {alertInfo.open &&
                    <CustomAlert
                        message={alertInfo.message}
                        severity={alertInfo.severity}
                    />
                }
            </Box>
        </LayoutBase>
    );
};